export default __webpack_public_path__ + "static/media/image_04.0cd62983.png";